/**
 * Datas vindas da API em dois formatos:
 *  - data pura "2026-10-01": o JS interpreta como meia-noite UTC e, no Brasil (UTC-3),
 *    exibe o dia anterior (30/09). Aqui ela é lida como data LOCAL.
 *  - data/hora "2026-10-01T10:00:00": já é lida como hora local; segue o fluxo normal.
 */
export const parseLocalDate = (value: string | Date | null | undefined): Date | null => {
    if (!value) return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
    const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
    const date = dateOnly
        ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
        : new Date(value);
    return isNaN(date.getTime()) ? null : date;
};

/** dd/MM/yyyy (pt-BR) ou '-' quando vazio/inválido. */
export const formatDateBR = (value: string | Date | null | undefined, fallback = '-'): string => {
    const date = parseLocalDate(value);
    return date ? date.toLocaleDateString('pt-BR') : fallback;
};
